import * as React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { getCurrentTenant } from '../config/tenantConfig';

export default function HighlightedCard({ topMachineName, topMachineAmount }) {
  const { t } = useTranslation();
  const isVendai = getCurrentTenant().projectCode === 'VENDAI';

  return (
    <Paper
      elevation={1}
      sx={(theme) => ({
        height: '100%',
        px: 2,
        py: 2,
        backgroundColor: theme.palette.mode === "dark" ? "#1e4d2b" : "#e8f5e9",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: isVendai ? 'flex-start' : 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      })}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
        }}
      >
        <EmojiEventsRoundedIcon
          sx={(theme) => ({
            fontSize: 32,
            color: theme.palette.mode === 'dark' ? '#ffd700' : '#f9a825',
            opacity: 0.3,
          })}
        />
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontWeight: 600,
          display: 'block',
          mb: 1,
          fontSize: '0.9rem',
          textAlign: isVendai ? 'left' : 'center',
        }}
      >
        {t('vendingSales.topSellingMachineByAmount', 'En Çok Satış Yapan Otomat (Tutar)')}
      </Typography>

      <Box sx={{ my: 1, textAlign: isVendai ? 'left' : 'center' }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: '700',
            color: 'text.primary',
            mb: 1,
          }}
        >
          {topMachineName || t('vendingSales.noData', 'Veri Yok')}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: '700',
            color: '#2e7d32',
          }}
        >
          {topMachineAmount
            ? `${(topMachineAmount / 100).toLocaleString('tr', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ₺`
            : '0,00 ₺'
          }
        </Typography>
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          mt: 0.5,
          fontSize: '0.75rem',
        }}
      >
        {t('vendingSales.totalSalesAmount', 'Toplam Satış Tutarı')}
      </Typography>
    </Paper>
  );
}

HighlightedCard.propTypes = {
  topMachineName: PropTypes.string,
  topMachineAmount: PropTypes.number,
};
